import { paletteOf } from "@/shared/palettes";

/**
 * Paint a palette onto the document.
 *
 * Writes the SAME custom properties the stylesheet already declares, so every
 * component keeps using `--color-clay-500` and nothing has to know a palette
 * exists. A house that has never chosen one gets `lut`, which is what those
 * properties are set to in the stylesheet anyway — so this is a no-op rather
 * than a flash of the wrong colour.
 */
export function applyPalette(name: string | null | undefined): void {
  const p = paletteOf(name);
  const root = document.documentElement.style;
  root.setProperty("--color-clay-500", p.accent);
  root.setProperty("--color-clay-600", p.accentDeep);
  root.setProperty("--color-clay-700", p.accentDeep);
  root.setProperty("--color-clay-50", p.accentPale);
  root.setProperty("--color-clay-300", p.accent);
  root.setProperty("--color-olive-500", p.secondary);
  root.setProperty("--color-olive-600", p.secondaryDeep);
  root.setProperty("--color-olive-800", p.secondaryDeep);
  root.setProperty("--color-olive-100", p.secondaryPale);
  root.setProperty("--primary", p.accent);
  root.setProperty("--secondary", p.secondary);
  root.setProperty("--ring", p.accent);
}
